import { phoneNumbers, PolicyDetails } from "shared";

import { DriverV2 } from "@hagerty/customer-insurance-gateway-client";
import { Info } from "@hagerty/icons";

import { ListCard } from "../../ListCard";
import { Link } from "../../Link";
import { getCustomerAge } from "../../../utils/getCustomerAge";

import styles from "./DriversListCard.module.scss";

export type DriversListCardProps = {
  policy: PolicyDetails;
};

const insuredType = {
  PRIMARY: "Primary insured",
  SECONDARY: "Secondary insured",
  DEPENDENT: "Dependent",
  OTHER: "Other",
};

const getInsured = (driver: DriverV2) => {
  if (!driver.isVehicleOperator) {
    return "Other";
  }

  return (
    insuredType[driver.driverType as keyof typeof insuredType] ||
    insuredType.OTHER
  );
};

export const DriversListCard = ({ policy }: DriversListCardProps) => {
  return (
    <ListCard>
      <ListCard.Header>Drivers</ListCard.Header>
      <ListCard.ExpandableRows
        maxRowCount={5}
        viewRowsLabel="View drivers"
        hideRowsLabel="Hide drivers"
        hasFooter
      >
        {policy.drivers.map((driver, index) => (
          <ListCard.Row key={index}>
            <div className={styles.column}>
              <div className={styles.name}>
                {driver.name.prefix} {driver.name.first} {driver.name.last}{" "}
                {driver.name.suffix}
              </div>
              <div className={styles.details}>
                {getInsured(driver)}, Age {getCustomerAge(driver.dateOfBirth)}
              </div>
            </div>
          </ListCard.Row>
        ))}
      </ListCard.ExpandableRows>
      <ListCard.Footer>
        <div className={styles.footer}>
          <Info />
          <div>
            Please call{" "}
            <Link phoneNumber={phoneNumbers.auto}>{phoneNumbers.auto}</Link> to
            add or edit drivers.
          </div>
        </div>
      </ListCard.Footer>
    </ListCard>
  );
};
